export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * 邮箱校验
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  /* eslint-disable */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable */
  return re.test(email)
}

/**
 * 手机号码校验
 * 
 * @param {String} phone
 */
export function validatePhone(phone) {
  const re = /^1[3|4|5|7|8][0-9]\d{8}$/
  return re.test(phone)
}

/**
 * 校验密码
 *
 * @param {String} password
 */
// export function validatePassword(password) {

// }


/**
 * 校验图片是否存在
 *
 * @param {String} url
 */
export function validateImage(url) {
  return new Promise(function(resolve) {
    var img = new Image();
    img.src = url;
    if(img.complete) {
      resolve(true)
    }
    img.onload = function() {
      resolve(true)
    }
    img.onerror = function() {
      resolve(false)
    }
  })
}
/**
 * 判断是否是IE
 * @returns boolean
 */
function isIE() {
  if (!!window.ActiveXobject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
}
/**
 * 判断是否是IE11
 * @returns boolean
 */
function isIE11() {
  if((/Trident\/7\./).test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}
/**
 * 校验视频是否存在
 *
 * @param {String} url
 */
export function validateVideo(src) {
  return new Promise((res) => {
    let videoDOM = document.createElement('video')
    videoDOM.style.opacity = 0;
    videoDOM.src = src
    document.body.appendChild(videoDOM)
    // 检测网络状态   0.此元素未初始化 1.正常但没有使用网络 2.正在下载数据 3.没有找到资源
    // if(videoDOM.networkState === 3) {
    // }
    videoDOM.oncanplay = function() {
      console.log('视频成功');
      if(isIE() || isIE11()) {
        videoDOM.removeNode(true)
      }else{
        videoDOM.remove()
      }
      res(true)
    }
    videoDOM.onerror = function() {
      console.log('视频失败');
      if(isIE() || isIE11()) {
        videoDOM.removeNode(true)
      }else{
        videoDOM.remove()
      }
      res(false)
    }
  })
}
